/**
 * @generated SignedSource<<5cef9a3fb97a03cd551c2fd5e6b38617>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type trendingNavBarSwiperQueueQuery$variables = Record<PropertyKey, never>;
export type trendingNavBarSwiperQueueQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type trendingNavBarSwiperQueueQuery = {
  response: trendingNavBarSwiperQueueQuery$data;
  variables: trendingNavBarSwiperQueueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "pwa_subnav_menu"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"pwa_subnav_menu\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "trendingNavBarSwiperQueueQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "trendingNavBarSwiperQueueQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f6221c599b1633717988fc28b7cc0f13",
    "id": null,
    "metadata": {},
    "name": "trendingNavBarSwiperQueueQuery",
    "operationKind": "query",
    "text": "query trendingNavBarSwiperQueueQuery {\n  appConfig(filter: {entityId: \"pwa_subnav_menu\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "85aecf011fc267e1108d17afba50254d";

export default node;
